import React from 'react';
import proptypes from 'prop-types';
import { GraphQLError } from 'graphql/error/GraphQLError.js';
import { InMemoryCache } from '@apollo/client';
import { MockedProvider as ApolloMockedProvider, MockLink } from '@apollo/client/testing';
import { typePolicies, dataIdFromObject } from '../react/util';
import possibleTypes from '../shapes/possibleTypes';
import { createMock, mockRequestResponse } from './createMock';

const { node, bool, shape, arrayOf } = proptypes;
const staticCache = new InMemoryCache({
  typePolicies,
  dataIdFromObject,
  possibleTypes,
  addTypename: false,
});

const MockedProvider = ({
  children,
  addTypename = false,
  cache: paramsCache = null,
  mocks,
  useStaticCache = true,
  link = undefined
}) => {

  const defaultCache = new InMemoryCache({
    typePolicies,
    dataIdFromObject,
    possibleTypes,
    addTypename: false,
  });

  // eslint-disable-next-line react/destructuring-assignment
  const cache = useStaticCache
    ? staticCache
    : defaultCache;

  if (typeof window !== 'undefined' && window.__APOLLO_STATE__) {//eslint-disable-line
    cache.restore(window.__APOLLO_STATE__);//eslint-disable-line
  }
  return (
    <ApolloMockedProvider
      // addTypename // do not add this field
      cache={paramsCache || cache}
      addTypename={addTypename}
      mocks={mocks}
      link={link}
    >
      {children}
    </ApolloMockedProvider>
  );
};

MockedProvider.propTypes = {
  children: node.isRequired,
  addTypename: bool,
  cache: shape({}),
  mocks: arrayOf(shape({})).isRequired,
  useStaticCache: bool,
  link: shape({})
};

export {
  MockedProvider,
  MockLink,
  createMock,
  mockRequestResponse,
  GraphQLError
};
